// extracted by css-extract-rspack-plugin
export default {"cls1":"UngatedWorkCardDownloadCount-cls1_22D","cls2":"UngatedWorkCardDownloadCount-cls2_oTL UngatedWorkCardDownloadCount-cls1_22D"};